export const COLOUR = 'Colour';
export const SIZE = 'Size';
export const CUSTOM = 'Custom';
export const FILTER_CUSTOM_CLASS = 'tw-flex tw-flex-col tw-gap-[12px]';
export const COLOR_DIFF_LAYOUT = ['layout2', 'layout3'];
export const FILTER_CUSTOM_CLASS_2 = 'tw-flex tw-items-center tw-gap-[16px] tw-flex-wrap';
export const HEADING_TYPE_IMAGE = 'image';
export const IS_TEXT_ON_IMAGE = 'on-image';
export const PAGINATION = 'add-pagination';

export const FILTER_OPTIONS_SNF_WIDGET = {
  // Filter options of AdvCatalogMiddleBody ( aka SortAndFilter Widget )
  COLLECTION: 'Collections',
  CATEGORIES: 'Categories',
  TAGS: 'Tags',
  BRANDS: 'Brands',
  PRICE_RANGE: 'Price Range',
  SIZE: 'Size',
};
